import React from 'react'

const People = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className='container'>
      <div className='row'>
        {block.items.map((item, index) => {
          return <div key={index} className='col-lg-3 col-md-4 col-6'>
            <div className='card'>
              {item.image && (
                <div className='card-image'>
                  <img src={item.image} alt={item.name} title={item.name} />
                </div>
              )}
              <div className='content-wr'>
                {item.name && ( <h5>{item.name}</h5> )}
                {item.position && ( <p>{item.position}</p> )}
              </div>
            </div>
          </div>
        })}
      </div>
    </div>
  </section>
)

export default People
